<template>
  <div v-if="visible" class="d-flex flex-wrap justify-end">
    <v-btn
      v-if="item.kind === 'sales_order' && item.actions.can_create_po_from_so && hasPermissions('stock-purchase-orders-create')"
      x-small
      class="mr-1 mb-1"
      @click="$emit('create-po-from-so', item)"
    >
      {{ $t("DEALS.VIEW.CREATE_PO_FROM_SO") }}
    </v-btn>
    <v-btn
      v-if="item.kind === 'sales_order' && item.actions.can_create_delivery && hasPermissions('stock-sales-create')"
      x-small
      color="primary"
      class="mr-1 mb-1"
      @click="$emit('create-delivery-from-so', item)"
    >
      {{ $t("STOCK.SALES_ORDERS.CREATE_DELIVERY") }}
    </v-btn>
    <v-btn
      v-if="item.kind === 'sales_order' && item.actions.can_organize_transport && hasPermissions('stock-transport-orders-create')"
      x-small
      class="mr-1 mb-1"
      @click="$emit('organize-transport-from-so', item)"
    >
      {{ $t("STOCK.TRANSPORT_ORDERS.ORGANIZE_TRANSPORT") }}
    </v-btn>
    <v-btn
      v-if="item.kind === 'purchase_order' && item.actions.can_create_receipt && hasPermissions('stock-receipts-create')"
      x-small
      color="primary"
      class="mr-1 mb-1"
      @click="$emit('create-receipt-from-po', item)"
    >
      {{ $t("STOCK.PURCHASE_ORDERS.CREATE_RECEIPT") }}
    </v-btn>
    <v-btn
      v-if="item.kind === 'purchase_order' && item.actions.can_organize_transport && hasPermissions('stock-transport-orders-create')"
      x-small
      class="mr-1 mb-1"
      @click="$emit('organize-transport-from-po', item)"
    >
      {{ $t("STOCK.TRANSPORT_ORDERS.ORGANIZE_TRANSPORT") }}
    </v-btn>
    <v-btn
      v-if="item.kind === 'transport_order' && item.actions.can_create_receipt && hasPermissions('stock-receipts-create')"
      x-small
      color="primary"
      class="mr-1 mb-1"
      @click="$emit('create-receipt-from-to', item)"
    >
      {{ $t("STOCK.TRANSPORT_ORDERS.CREATE_RECEIPT") }}
    </v-btn>
    <v-btn
      v-if="item.kind === 'transport_order' && item.actions.can_create_delivery && hasPermissions('stock-sales-create')"
      x-small
      color="primary"
      class="mr-1 mb-1"
      @click="$emit('create-delivery-from-to', item)"
    >
      {{ $t("STOCK.TRANSPORT_ORDERS.CREATE_DELIVERY") }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "DealWorkflowActions",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    visible() {
      const item = this.item;
      const actions = item.actions || {};

      if (item.kind === "sales_order") {
        return (
          (actions.can_create_po_from_so && this.hasPermissions("stock-purchase-orders-create"))
          || (actions.can_create_delivery && this.hasPermissions("stock-sales-create"))
          || (actions.can_organize_transport && this.hasPermissions("stock-transport-orders-create"))
        );
      }

      if (item.kind === "purchase_order") {
        return (
          (actions.can_create_receipt && this.hasPermissions("stock-receipts-create"))
          || (actions.can_organize_transport && this.hasPermissions("stock-transport-orders-create"))
        );
      }

      if (item.kind === "transport_order") {
        return (
          (actions.can_create_receipt && this.hasPermissions("stock-receipts-create"))
          || (actions.can_create_delivery && this.hasPermissions("stock-sales-create"))
        );
      }

      return false;
    },
  },
};
</script>
